import { fetchGet, fetchPost, fetchPut, fetchDelete } from '../services/Apiservice'
import { bannerSlideFormUploader } from './formuploader/banner'

/**
 * Get banner list from API
 */
export const bannerList = (data) => {
    return fetchGet('/banners', data)
        .then((res) => res)
        .catch((res) => { throw res })
}

/**
 * Get banner details (with slides) from API
 */
export const bannerDetail = (id) => {
    return fetchGet(`/banners/${id}`)
        .then((res) => res)
        .catch((res) => { throw res })
}

/**
 * Create new banner through API (no file upload — plain JSON)
 */
export const bannerCreate = (data) => {
    return fetchPost('/banners', data)
        .then((res) => res)
        .catch((res) => { throw res })
}

/**
 * Edit banner details through API (no file upload — plain JSON)
 */
export const bannerEdit = (id, data) => {
    return fetchPut(`/banners/${id}`, data)
        .then((res) => res)
        .catch((res) => { throw res })
}

/**
 * Delete banner through API
 */
export const bannerDelete = (id) => {
    return fetchDelete(`/banners/${id}`)
        .then((res) => res)
        .catch((res) => { throw res })
}

/**
 * Create new banner slide through API (multipart — includes image upload)
 */
export const bannerSlideCreate = (bannerId, data) => {
    const formData = bannerSlideFormUploader(data)

    return fetchPost(`/banners/${bannerId}/slides`, formData)
        .then((res) => res)
        .catch((res) => { throw res })
}

/**
 * Edit banner slide through API (multipart — includes image upload)
 */
export const bannerSlideEdit = (id, data) => {
    const formData = bannerSlideFormUploader(data)

    return fetchPut(`/banner-slides/${id}`, formData)
        .then((res) => res)
        .catch((res) => { throw res })
}

/**
 * Delete banner slide through API
 */
export const bannerSlideDelete = (id) => {
    return fetchDelete(`/banner-slides/${id}`)
        .then((res) => res)
        .catch((res) => { throw res })
}